<!--
 * @Author: ZhaoG
 * @Date: 2025-04-14 16:18:19
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-04-18 17:06:51
 * @FilePath: \pp-fe\src\app\shop\views\commListJccg.vue
 * @Description: 集采成果列表
-->
<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <!--高级搜索Begin-->
      <div class="ccui-advanced-search-wrapper ccui-clearfix">
        <el-search
          ref="elSearch"
          width="460px"
          :formProp="formData"
          @search="search"
          :isShowSearch="true"
          class="ccui-highsearch no-print"
        >
          <template slot="search">
            <el-date-picker
              v-model="formData.publishTime"
              searchLabel="发布时间"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
            <el-select
              v-model="formData.year"
              clearable
              searchLabel="年度"
              placeholder="请选择年度"
            >
              <el-option
                v-for="item in yearList"
                :key="item.dicKey"
                :label="item.dicValue"
                :value="item.dicKey"
              ></el-option>
            </el-select>
            <el-input
              v-model.trim="formData.region"
              clearable
              searchLabel="区域"
              placeholder="请输入区域模糊查询"
              slot="searchItem3"
            ></el-input>
            <!-- <el-select
              class="ccui-form-longInput"
              v-model="formData.region"
              searchLabel="所在区域"
              placeholder="请选择所在区域查询"
              clearable
            >
              <el-option
                v-for="item in locationCodeList"
                :key="item.addressCode"
                :label="item.addressName"
                :value="item.addressName"
              >
              </el-option>
            </el-select> -->
          </template>
          <el-date-picker
            v-model="formData.publishTime"
            searchLabel="发布时间"
            clearable
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            slot="searchItem1"
          >
          </el-date-picker>
          <el-select
            v-model="formData.year"
            clearable
            searchLabel="年度"
            placeholder="请选择年度"
            slot="searchItem2"
          >
            <el-option
              v-for="item in yearList"
              :key="item.dicKey"
              :label="item.dicValue"
              :value="item.dicKey"
            ></el-option>
          </el-select>
          <el-input
            v-model.trim="formData.region"
            clearable
            searchLabel="区域"
            placeholder="请输入区域模糊查询"
            slot="searchItem3"
          ></el-input>

          <!-- <el-select
            class="ccui-form-longInput"
            v-model="formData.region"
            searchLabel="所在区域"
            placeholder="请选择所在区域查询"
            slot="searchItem3"
            clearable
          >
            <el-option
              v-for="item in locationCodeList"
              :key="item.addressCode"
              :label="item.addressName"
              :value="item.addressName"
            >
            </el-option>
          </el-select> -->
        </el-search>
      </div>
      <!--高级搜索End-->
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          :border="border"
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
        >
          <!--列表中的插槽Begin-->
          <!-- <template slot="title" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="check(row)"
            >
              {{ row[title] }}
            </el-button>
          </template> -->
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import {
  qryAddressRegion // 查询大区接口
} from "@/app/shop/api/shopping";
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import moment from "moment";
export default {
  name: "list",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  activated() {
    this.getNoticeList();
  },
  deactivated() {
    this.initData();
  },
  props: {
    currBreadCrumb: {
      type: Array,
      default: () => {
        return [];
      }
    },
    callInterface: {
      type: Function
    },
    rowsField: {
      type: String,
      default: "rows"
    },
    source: {
      //默认是通知公告
      type: String,
      default: ""
    },
    sourceId: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "title"
    },
    activeIndex: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      locationCodeList: [],
      yearList: [
        {
          dicKey: "2023",
          dicValue: "2023"
        },
        {
          dicKey: "2024",
          dicValue: "2024"
        },
        {
          dicKey: "2025",
          dicValue: "2025"
        }
      ], //年度
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      border: true,
      formData: {},
      formDataSearch: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [
        {
          label: "序号",
          prop: "id",
          type: "index",
          width: commonTableWidth.serialNoWidth,
          checked: true,
          fixed: "left",
          align: "left"
        },
        // {
        //   label: "标题",
        //   prop: "title",
        //   checked: true,
        //   // width: 500,
        //   slot: "title"
        // },
        {
          label: "年度",
          prop: "year",
          width: "100",
          checked: true,
          fixed: "left",
          align: "left"
        }
      ],
      unfixedTableThead: Object.freeze([
        {
          label: "区域",
          prop: "area",
          width: "150",
          checked: true,
          align: "left"
        },
        {
          label: "省份",
          prop: "province",
          width: "150",
          checked: true,
          align: "left"
        },
        {
          label: "品类",
          prop: "category",
          width: "150",
          checked: true,
          align: "left"
        },
        {
          label: "集团名称(全称)",
          prop: "groupName",
          width: "300",
          checked: true,
          align: "left"
        },
        {
          label: "源头厂家名称(与集团签署集采协议的乙方)",
          prop: "originalFactory",
          width: "350",
          checked: true,
          align: "left"
        },
        {
          label: "生产厂家名称(与各单位签署具体采购合同的乙方)",
          prop: "productFactory",
          width: "350",
          checked: true,
          align: "left"
        },
        {
          label: "品牌",
          prop: "brand",
          width: "150",
          checked: true,
          align: "left"
        },
        {
          label: "价格机制",
          prop: "priceMechanism",
          width: "300",
          checked: true,
          align: "right"
        },
        {
          label: "运输方式及定价结算模式",
          prop: "transportPrice",
          width: "300",
          checked: true,
          align: "left"
        },
        {
          label: "支付方式",
          prop: "payType",
          width: "150",
          checked: true,
          align: "left"
        },
        {
          label: "中标人的联系人和联系方式",
          prop: "bidWinnerInfo",
          width: "200",
          checked: true,
          align: "left"
        },
        {
          label: "备注",
          prop: "remark",
          width: "200",
          checked: true,
          align: "left"
        },
        {
          label: "发布时间",
          prop: "importTime",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      otherParams: {
        appId: 100125,
        module: 1,
        pageState: 2
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      // 查询大区
      const data1 = (await qryAddressRegion({})).data.data;
      this.locationCodeList = data1;
    },
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      if (this.source) {
        let param = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          isShowPageLoading: true,
          searchNoticeType: this.source
        };
        if (
          this.formDataSearch.publishTime &&
          this.formDataSearch.publishTime.length !== 0
        ) {
          this.formDataSearch.importTimeStart =
            this.formDataSearch.publishTime[0] + " 00:00:00";
          this.formDataSearch.importTimeEnd =
            this.formDataSearch.publishTime[1] + " 23:59:59";
        }
        Object.assign(param, this.formDataSearch);
        this.$delete(param, "publishTime");
        console.log(param, "22222222222222222222222222");
        this.callInterface(param).then(res => {
          if (res.data.code === "0") {
            this.tableData = res.data.data.rows.map(item => {
              item.title = item.noticeTitle ? item.noticeTitle : "";
              // item.importTime = item.noticeStartTime
              //   ? moment(item.noticeStartTime).format("YYYY-MM-DD HH:mm")
              //   : "";
              return item;
            });
            this.pageTotal = res.data.data.recordsTotal;
          }
        });
      } else {
        let param = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          isShowPageLoading: true,
          searchNoticeType: "",
          faqProblemId: this.$route.query.sourceId
        };
        if (
          this.formDataSearch.publishTime &&
          this.formDataSearch.publishTime.length !== 0
        ) {
          this.formDataSearch.importTimeStart =
            this.formDataSearch.publishTime[0] + " 00:00:00";
          this.formDataSearch.importTimeEnd =
            this.formDataSearch.publishTime[1] + " 23:59:59";
        }
        Object.assign(param, this.formDataSearch);
        this.$delete(param, "publishTime");
        this.callInterface(param).then(res => {
          if (res.data.code === "0") {
            this.tableData = res.data.data.rows.map(item => {
              item.title = item.noticeTitle ? item.noticeTitle : "";
              // item.importTime = item.noticeStartTime
              //   ? moment(item.noticeStartTime).format("YYYY-MM-DD HH:mm")
              //   : "";
              // return item;
            });
            this.pageTotal = res.data.data.recordsTotal;
          }
        });
      }
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.getNoticeList();
    },
    //查看
    check(row) {
      // 工作动态和通知公告
      this.$router.push({
        path: "/announcementDetailNew",
        query: {
          id: row.noticeId,
          noticeId: row.noticeId,
          type: row.type,
          activeIndex: this.$route.query.activeIndex,
          source: this.$route.query.source,
          sourceId: this.$route.query.sourceId,
          parentId: this.$route.query.parentId
        }
      });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-form-item__content {
  width: 149px;
}
</style>
